import http from './_http'

const notice = {
  get: (id) => http.get(`api/v3/board/notice/${id}`),
  list: (m) => http.post(`api/v3/board/notice/search`, m),
  add: (m) => http.post(`api/v3/board/notice`, m),
  update: (m) => http.put(`api/v3/board/notice`, m),
  delete: (id) => http.delete(`api/v3/board/notice/${id}`),
}
const faq = {
  get: (id) => http.get(`api/v3/board/faq/${id}`),
  list: (m) => http.post(`api/v3/board/faq/search`, m),
}
const qna = {
  get: (id) => http.get(`api/v3/board/qna/${id}`),
  list: (m) => http.post(`api/v3/board/qna/search`, m),
  add: (m) => http.post(`api/v3/board/qna`, m),
  update: (id, m) => http.put(`api/v3/board/qna/${id}`, m),
  remove: (id) => http.delete(`api/v3/board/qna/${id}`),
}

const board  = {
  notice, faq, qna
}
export default board
export { notice, faq, qna }